export default __webpack_public_path__ + "static/media/BoathouseMap.820fb142.jpg";